// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MqX0u","newExpiryDate":"styles_newExpiryDate__3HLne","footer":"styles_footer__2JIrc"};